import Relay from 'react-relay/classic';
import RelayGraphQLMutation from 'react-relay/lib/RelayGraphQLMutation';

export default class updateBlockPerformanceMutation {
  constructor(props) {
    this.props = props;
  }

  commit(callbacks) {
    const isAssigned = !!this.props.coursePerformanceId;

    const query = Relay.QL`
      mutation updateBlockPerformanceMutation($input: UpdateBlockPerformanceInput!) {
        updateBlockPerformance(input: $input) {
          cardPerformance {
            blockPerformance
            scaledProgressMeasure
            progressMeasure
          }
          clientMutationId
        }
      }
    `;

    const variables = {
      input: {
        courseId: this.props.courseId,
        cardId: this.props.cardId,
        userId: this.props.userId,
        blockPerformance: this.props.blockPerformance
      }
    };

    const mutation = new RelayGraphQLMutation(query, variables, null, Relay.Store, callbacks);

    const config = [{ type: 'FIELDS_CHANGE' }];
    config[0].fieldIDs = {
      cardPerformance: this.props.mainId
    };

    const optimisticQuery = Relay.QL`
    mutation updateBlockPerformanceMutation($input: UpdateBlockPerformanceInput!) {
      updateBlockPerformance(input: $input) {
        cardPerformance {
          blockPerformance
          scaledProgressMeasure
          progressMeasure
        }
      }
    }`;

    const optimisticResponse = {
      cardPerformance: {
        blockPerformance: this.props.blockPerformance,
        scaledProgressMeasure: this.props.blockPerformance,
        progressMeasure: this.props.blockPerformance
      }
    };

    isAssigned && mutation.applyOptimistic(optimisticQuery, optimisticResponse, config);
    mutation.commit(config);
  }
}
